import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'multiSelectTooltip',
  standalone: true
})
export class MultiSelectTooltipPipe implements PipeTransform {

  transform(filter: any, value: any): string {
    if (!value || !Array.isArray(value) || value.length === 0) {
      return filter.placeholder;
    }

    return value.map((x: any) => {
      // If x is already an object with the expected property
      if (typeof x === 'object' && x !== null && x[filter.optionLabel ?? 'name']) {
        return x[filter.optionLabel ?? 'name'];
      }
      
      // If x is a primitive value, try to find the corresponding label in options
      if (filter.options && (typeof x === 'number' || typeof x === 'string')) {
        const matchingOption = filter.options.find((option: any) => option.value === x);
        return matchingOption ? matchingOption[filter.optionLabel ?? 'name'] : x;
      }
      
      // Fallback: return the value as-is
      return x;
    }).filter(label => label !== undefined && label !== null).join(', ');
  }
}
